import { createContext, useContext, useState } from "react";
import {
  getUser,
  getToken,
  saveAuth,
  clearAuth,
} from "../services/authService";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const stored = getUser();
    return stored; // getUser already returns parsed object or null
  });

  const login = (authData) => {
    saveAuth(authData);
    setUser(authData.user);
  };

  const logout = () => {
    clearAuth();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, isLoggedIn: !!user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
